import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyState = () => {
  return (
    <Box justifyContent="center" width="full" flexDirection="row" padding="s12">
      <Text.Normal size="200">
        {i18n.t('finance.cost_centers.assignments.empty_assignments')}
      </Text.Normal>
    </Box>
  )
}
